
import { call, put } from 'redux-saga/effects';

import { requestFailed } from '~src/app/actions/RequestFailedAction';
import { Messages } from '~src/codegen/Localize';
import { FlowBaseInfo } from '~src/flow/models/FlowInfo';
import { openCreateFlowRunTaskDialog } from '~src/flow/utils/FlowDialogUtils';

import { ScheduleLinkedTaskReduxAction } from '../actions/ScheduleLinkedTaskAction';
import { ScheduleSingleFlowTaskReduxAction } from '../actions/ScheduleSingleFlowTaskAction';


export function* handleScheduleSingleFlowTask(action: ScheduleSingleFlowTaskReduxAction) {
  try {
    yield call(openCreateFlowRunTaskDialog, action.flow as FlowBaseInfo);
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}


export function* handleScheduleLinkedTask(action: ScheduleLinkedTaskReduxAction) {
  try {
    yield call(openCreateFlowRunTaskDialog, action.flow as FlowBaseInfo, undefined, true);
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}
